import { environment } from 'environments/environment';
import { plural } from 'pluralize';
import { navigation } from '../../navigation/navigation';
import { ProcessType } from '../models/process-type';
import { SubjectType } from '../models/subject-type';
import { enumUserRole } from './user-management.service';

export class NavigationHelper {
  static privs: string;
  static canViewArchive: boolean = false;
  static canExportData: boolean = false;
  static subjectTypes: SubjectType[];
  static processTypes: ProcessType[];
  static myTasksCount = 0;
  static allTasksCount = 0;
  static markerSearchEnabled = false;
  static referralsEnabled = false;
  static assessmentsEnabled = false;
  static onlineReportingEnabled = false;
  static emailTemplatesEnabled = false;
  static evidenceUploadEnabled = false;
  static enableFOIFeature = false;
  static updateNavigation(): any {
    const nav: any = navigation;

    let role = enumUserRole.User;

    var privsList = this.privs.trim().toLowerCase().split(',');
    if (privsList.find((i) => i.toLowerCase().trim() == 'searchonly'))
      role = enumUserRole.SearchOnly;
    if (privsList.find((i) => i.toLowerCase().trim() == 'subjectalertimport'))
      role = enumUserRole.SubjectAlertImport;
    if (privsList.find((i) => i.toLowerCase().trim() == 'readonly'))
      role = enumUserRole.ReadOnly;
    if (privsList.find((i) => i.toLowerCase().trim() == 'admin'))
      role = enumUserRole.Admin;
    if (privsList.find((i) => i.toLowerCase().trim() == 'orgmanager'))
      role = enumUserRole.OrgManager;
    if (privsList.find((i) => i.toLowerCase().trim() == 'sysadmin'))
      role = enumUserRole.SysAdmin;
    if (privsList.find((i) => i.toLowerCase().trim() == 'multiorgadmin'))
      role = enumUserRole.MultiOrgAdmin;

    // if role is Subject Alert Import then hide everything other than the Subject Alert Import page
    if (role === enumUserRole.SubjectAlertImport)
    {     
      nav[0].children.map((i) => {
        i.type = i.id.toLowerCase().includes('subject_alert_import')
          ? 'item'
          : 'HIDDEN';
      });
      return nav;   
    }
    else
    {
      if (role!== enumUserRole.SysAdmin)
      {
        // Else hide Subject Alert Import from nav.
        nav[0].children.map((i) => {
          if (i.id.toLowerCase().includes('subject_alert_import'))
            i.type ='HIDDEN';
        });
      }
    }

    // if role is search only then hide everything other than the search group
    if (role === enumUserRole.SearchOnly) {
      nav[0].children.map((i) => {
        i.type = i.id.toLowerCase().includes('markersearch')
          ? 'collapse'
          : 'HIDDEN';
      });
      const wsm = nav[0].children.filter(
        (item) => item.id.toLowerCase().indexOf('markersearch') >= 0
      );
      if (wsm && wsm.length > 0) {
        wsm[0].type = !this.markerSearchEnabled ? 'HIDDEN' : 'collapse';
      }
      return nav;
    }

    // if got here then user, readonly, ORGMANAGER, admin or sysadmin...

    // check for intec admin group and hide if don't have sysadmin role
    const sysAdminMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('intecadmin') >= 0
    );
    if (sysAdminMenu && sysAdminMenu.length > 0) {
      // if not SysAdmin remove intec admin menu option
      if (role !== enumUserRole.SysAdmin) {
        // remove intec admin maintenance menu option by setting the Type to 'Hidden'- this will hide the menu from the user. the Auth Guard will stop users
        // going direct to the route
        sysAdminMenu[0].type = 'HIDDEN';
      } else {
        // Restore menu
        sysAdminMenu[0].type = 'collapse';
      }
    }

    // patch import menu options
    // if we are sysadmin then display the import group...
    const sysImportMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('importgroup') >= 0
    );
    if (sysImportMenu && sysImportMenu.length > 0) {
      sysImportMenu[0].type =
        role !== enumUserRole.SysAdmin ? 'HIDDEN' : 'collapse';
    }

    // ..if we are not sysadmin and not read only then display the import item
    const importMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase() === 'import'
    );
    if (importMenu && importMenu.length > 0) {
      importMenu[0].type =
        role === enumUserRole.ReadOnly || role === enumUserRole.SysAdmin || role === enumUserRole.MultiOrgAdmin
          ? 'HIDDEN'
          : 'item';
    }

    // if sysadmin then display report designer
    const reportMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('reportgroup') >= 0
    );
    if (reportMenu) {
      reportMenu[0].type =
        role === enumUserRole.ReadOnly ? 'HIDDEN' : 'collapse';

      // only display referral reports if limitAccessToSubjectsByOrg is set to true (PJT says this is in effect AAB 'mode' on)
      const referralReportsMenu = reportMenu[0].children.filter(
        (item) => item.id.toLowerCase() == 'referralreports'
      );
      if (referralReportsMenu && referralReportsMenu.length > 0) {
        referralReportsMenu[0].type =
          environment.limitAccessToSubjectsByOrg === true ? 'item' : 'HIDDEN';
      }

      const systemReportsMenu = reportMenu[0].children.filter(
        (item) => item.id.toLowerCase() == 'reports'
      );
      if (systemReportsMenu && systemReportsMenu.length > 0) {
        systemReportsMenu[0].type =
          environment.limitAccessToSubjectsByOrg === false ? 'item' : 'HIDDEN';
      }

      // if sysadmin then display report designer
      const reportDesignerMenu = reportMenu[0].children.filter(
        (item) => item.id.toLowerCase().indexOf('reportdesigner') >= 0
      );
      if (reportDesignerMenu && reportDesignerMenu.length > 0) {
        reportDesignerMenu[0].type =
          role !== enumUserRole.SysAdmin ? 'HIDDEN' : 'item';
      }

      const reportExtractMenu = reportMenu[0].children.filter(
        (item) => item.id.toLowerCase().indexOf('reportextract') >= 0
      );

      if (reportExtractMenu && reportExtractMenu.length > 0) {
        reportExtractMenu[0].type =
          (role !== enumUserRole.Admin && role !== enumUserRole.SysAdmin) || !this.canExportData
            ? 'HIDDEN'
            : 'item';
      }

      const reportDashboardMenu = reportMenu[0].children.filter((item) => item.id.toLowerCase().indexOf('reportdashboard') >= 0);
      if (reportDashboardMenu && reportDashboardMenu.length > 0) {
        reportDashboardMenu[0].type =
          ((environment.enableBIDashboardAccess && role == enumUserRole.Admin) || role == enumUserRole.SysAdmin) &&
          this.canExportData
            ? 'item'
            : 'HIDDEN';
      }
    }

    // check for system maintenance group and hide if don't have admin role
    const sysMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('systemmaintenance') >= 0
    );
    if (sysMenu && sysMenu.length > 0) {
      // if not Admin remove system maintenance menu option
      if (
        role !== enumUserRole.Admin &&
        role !== enumUserRole.SysAdmin &&
        role !== enumUserRole.OrgManager
      ) {
        // remove System maintenance menu option by setting the Type to 'Hidden'- this will hide the menu from the user. the Auth Guard will stop users
        // going direct to the route
        sysMenu[0].type = 'HIDDEN';
      } else {
        // Restore menu
        sysMenu[0].type = 'collapse';

        if (role === enumUserRole.OrgManager) {
          // When user is Organisation Admin, then only show the User Management if limitAccessToSubjectsByOrg, else hidden
          sysMenu[0].children.forEach((item) => {
            if (
              item.id.toLowerCase() == 'user_management' &&
              environment.limitAccessToSubjectsByOrg === true
            )
              item.type = 'item';
            else {
              item.type = 'HIDDEN';
            }
            if (environment.limitAccessToSubjectsByOrg === true)
              sysMenu[0].type = 'collapse';
            else sysMenu[0].type = 'HIDDEN';
          });
        } else {
          const SelfManageOrganisationsMenu = sysMenu[0].children.filter(
            (item) =>
              item.id.toLowerCase().indexOf('self-manage-organisations') >= 0
          );
          if (
            SelfManageOrganisationsMenu &&
            SelfManageOrganisationsMenu.length > 0
          ) {
            SelfManageOrganisationsMenu[0].type =
              environment.allowAdminsToCreateOrganisations &&
              environment.limitAccessToSubjectsByOrg
                ? 'item'
                : 'HIDDEN';
          }

          // check for assessments group and hide if not enabled
          const assessmentsMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('assessments') >= 0
          );
          if (assessmentsMenu && assessmentsMenu.length > 0) {
            assessmentsMenu[0].type = !this.assessmentsEnabled
              ? 'HIDDEN'
              : 'collapse';
          }

          // check for online reporting and hide if not enabled
          const onlineReportingMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('onlinereporting') >= 0
          );
          if (onlineReportingMenu && onlineReportingMenu.length > 0) {
            onlineReportingMenu[0].type = this.onlineReportingEnabled
              ? 'item'
              : 'HIDDEN';
          }

          // check for referral sources and hide if not enabled
          const referralSourcesMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('referralsources') >= 0
          );
          if (referralSourcesMenu && referralSourcesMenu.length > 0) {
            referralSourcesMenu[0].type = this.referralsEnabled
              ? 'item'
              : 'HIDDEN';
          }

          // check for email templates and hide if not enabled
          const emailTemplateMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('emailtemplates') >= 0
          );
          if (emailTemplateMenu && emailTemplateMenu.length > 0) {
            emailTemplateMenu[0].type = this.emailTemplatesEnabled
              ? 'item'
              : 'HIDDEN';
          }

          // check for evidence upload and hide if not enabled
          const evidenceUploadMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('evidenceupload') >= 0
          );
          if (evidenceUploadMenu && evidenceUploadMenu.length > 0) {
            evidenceUploadMenu[0].type = this.evidenceUploadEnabled
              ? 'item'
              : 'HIDDEN';
          }

          const foiMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('foinonworkingdays') >= 0
          );
          if (foiMenu && foiMenu.length > 0) {
            foiMenu[0].type = NavigationHelper.enableFOIFeature ? 'item':'HIDDEN';
          }

          const retentionPeriodMenu = sysMenu[0].children.filter(
            (item) => item.id.toLowerCase().indexOf('retentionsettings') >= 0
          );
          if (retentionPeriodMenu && retentionPeriodMenu.length > 0) {
            retentionPeriodMenu[0].type = environment.enableRetentionFeature ? 'item':'HIDDEN';
          }          
        }
      }
    }

    // check for markersearch group and hide if not enabled or have readonly role
    const markerSearchMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('markersearch') >= 0
    );
    if (markerSearchMenu && markerSearchMenu.length > 0) {
      markerSearchMenu[0].type =
        !this.markerSearchEnabled || role === enumUserRole.ReadOnly || (role === enumUserRole.MultiOrgAdmin)
          ? 'HIDDEN'
          : 'collapse';
    }

    // check for referrals group and hide if not enabled and marker search not enabled
    const referralsMenu = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('referrals') >= 0
    );
    if (referralsMenu) {
      referralsMenu[0].type =
        this.referralsEnabled || this.markerSearchEnabled
          ? 'collapse'
          : 'HIDDEN';
      if (
        role !== enumUserRole.Admin &&
        role !== enumUserRole.SysAdmin &&
        role !== enumUserRole.OrgManager
      ) {
        const archiveMenu = referralsMenu[0].children.filter(
          (item) => item.id.toLowerCase().indexOf('archived-referrals') >= 0
        );
        //console.log(this.canViewArchive);
        if (archiveMenu && this.canViewArchive) {
          archiveMenu[0].type = 'item';
        } else {
          archiveMenu[0].type = 'HIDDEN';
        }

        const dueForDeletionMenu = referralsMenu[0].children.filter(
          (item) =>
            item.id.toLowerCase().indexOf('referrals-duefordeletion') >= 0
        );
        if (dueForDeletionMenu && this.canViewArchive) {
          dueForDeletionMenu[0].type = 'HIDDEN';
        }
      }
    }   

    // Reset navbar by removing any previously added entries...
    // filter out any navbar items starting with 'xx'
    const filtered = nav[0].children.filter(
      (item) => item.id.toLowerCase().indexOf('xx') < 0
    );
    filtered.forEach((child) => {
      if (child.children) {
        const f = child.children.filter(
          (x) => x.id.toLowerCase().indexOf('xx') < 0
        );
        if (f) {
          child.children = f;
        }
      }
    });
    nav[0].children = filtered;

    // add menu items for any process types...
    let index = 1;
    if (this.processTypes && this.processTypes.length > 0) {      
      const sortedProcessTypes = this.processTypes
                                      ?.filter(pt=>pt.isCheckList==undefined || pt.isCheckList===false)
                                      ?.sort((n1, n2) => { return n1.name.localeCompare(n2.name); });          

      index = nav[0].children.findIndex(
        (item) => item.id.toLowerCase() === 'processes'
      );
      if (index > -1) {
        sortedProcessTypes.forEach((processType) => {
          const navItem = {
            id: 'xxprocess-' + processType.name,
            title: plural(processType.name),
            type: 'item',
            url: `/processes/${processType.name}`,
            exactMatch: true,
          };
          NavigationHelper.addSubItem(nav, index, navItem);
        });
      }
    }

    // ...and now add menu items for any subject types
    index = 1;
    let primaryCount = 0;

    if (this.subjectTypes && this.subjectTypes.length > 0) {
      const sortedSubjectTypes = this.subjectTypes.sort((n1, n2) => {
        return n1.name.localeCompare(n2.name);
      });
      sortedSubjectTypes.forEach((subjectType) => {
        // if is marked as a primary subject then we need to add...
        if (subjectType.primary === true) {
          if (!((role === enumUserRole.ReadOnly) || (role === enumUserRole.MultiOrgAdmin))) {
            // ...Add X menu item
            const navAddItem = {
              id: 'xxaddPrimary' + subjectType.name,
              title: 'Add ' + subjectType.name,
              type: 'item',
              icon: 'add',
              url: `/subjects/${subjectType.name}/new`,
            };
            NavigationHelper.addNavItem(nav, index, navAddItem);
            index = index + 1;
          }

          // ...add X group for My/all menu options
          const pluralName = plural(subjectType.name);
          const navPrimaryGroup = {
            id: `xx${subjectType.name}-group`,
            title: pluralName,
            type: 'collapse',
            icon: 'shop_two',
            url: '/subjects',
            children: [
              {
                id: `my-${subjectType.name}`,
                title: 'My ' + pluralName,
                type: 'item',
                url: `/subjects/${subjectType.name}/u/my`,
                exactMatch: true,
                // badge: {
                //   title: 4,
                //   bg: '#F44336',
                //   fg: '#FFFFFF',
                // },
              },
              {
                id: `all-${subjectType.name}`,
                title: 'All ' + pluralName,
                type: 'item',
                url: `/subjects/${subjectType.name}/u/all`,
                exactMatch: true,
                // badge: {
                //   title: 3,
                //   bg: '#F44336',
                //   fg: '#FFFFFF',
                // },
              },
            ],
          };
          if (this.canViewArchive) {
            navPrimaryGroup.children.push({
              id: `archived-${subjectType.name}`,
              title: 'Archived ' + pluralName,
              type: 'item',
              url: `/subjects/${subjectType.name}/archived`,
              exactMatch: true,
            });
            if (
            role === enumUserRole.Admin ||
            role === enumUserRole.SysAdmin ||
            role === enumUserRole.OrgManager){
              // MRD - PD says the due for deletion should only be available for cases - we assume an id =1 as name could be changed by the user
              if (subjectType.id === 1) {
                navPrimaryGroup.children.push({
                  id: `delete-${subjectType.name}`,
                  title: pluralName + ' Due For Deletion',
                  type: 'item',
                  url: `/subjects/${subjectType.name}/duefordeletion`,
                  exactMatch: true,
                  // badge: {
                  //   title: 3,
                  //   bg: '#F44336',
                  //   fg: '#FFFFFF',
                  // },
                });
              }
            }
          }
          NavigationHelper.addNavItem(
            nav,
            index + primaryCount,
            navPrimaryGroup
          );
          primaryCount = primaryCount + 1;
        } else {
          // not a primary subject, add subject to subjects menu group
          const navItem = {
            id: 'xxsubject-' + subjectType.name,
            title: plural(subjectType.name),
            type: 'item',
            url: `/subjects/${subjectType.name}/u/all`,
            exactMatch: true,
          };
          NavigationHelper.addSubItem(nav, index + primaryCount, navItem);
        }
      });

      index = nav[0].children.findIndex(
        (item) => item.id.toLowerCase() === 'tasks'
      );
      if (index > 0) {
        const myTasksId = nav[0].children[index].children.findIndex(
          (item) => item.id.toLowerCase() === 'my-tasks'
        );
        const allTasksId = nav[0].children[index].children.findIndex(
          (item) => item.id.toLowerCase() === 'all-tasks'
        );
        if (myTasksId >= 0) {
          nav[0].children[index].children[myTasksId].badge.title =
            this.myTasksCount;
          nav[0].children[index].children[myTasksId].badge.tooltip =
            'Number of tasks assigned to you that are open or late';
        }
        if (allTasksId >= 0) {
          nav[0].children[index].children[allTasksId].badge.title =
            this.allTasksCount;
          nav[0].children[index].children[allTasksId].badge.tooltip =
            'Total number of tasks are open or late';
        }
      }
    }
    return nav;
  }

  static addNavItem(nav: any, index: number, navItem: any) {
    nav[0].children.splice(index, 0, navItem);
  }

  static addSubItem(nav: any, navigationChildId: number, navItem: any) {
    const parent = nav[0].children[navigationChildId];
    if (parent.type !== 'collapse') {
      parent.type = 'collapse';
      parent.children = [];
    }
    parent.children.push(navItem);
  }

  static updateBadge(nav: any, navigationChildId: number, title: number) {
    const navItem = nav[0].children[navigationChildId];
    navItem.badge.title = title;
  }
}
